var MessageEn = {

  NavabarText: {
    navbar_home: "Home",
    navbar_about: "About Us",
    navbar_product:"Product",
    navbar_case: "Case",
    navbar_contact: "Contact Us",
    navbar_item: "Services",
    navbr_new: 'News',
    navbr_join:'Join Us'
  },
  About_Navbar: {
     company: 'Company Overview',
    Horor: 'Awards & Accreditation',
    Technology: 'Technology ',
    Team: 'Our Team ',
  },

  New_NavBar: {
    Notice: 'Notice',
    MediaCentre: 'Media  centre',
  },
  indexText: {
    more: "Learn more",
    home_title:"Provide customized deep Internet",
    home_title_1:"Solution",
    web_build:"Website construction",
    phone_build:"Mobile website",
    min_build:"Applet customization",
    share_build:"Official account is customized",

    content_title_1: 'PC site building',

    content_title_content_1: 'A website focusing on marketing and SEO',

    content_title_description_1: "Massive high color value design templates + adaptive, supporting full screen DIY",

    content_title_description_1_1: "More professional SEO optimization, sitenam support and ensuring Baidu collection",

    content_title_description_1_2: "There are more languages, big data and employee sub accounts waiting for you to tease",

    content_title_2: 'Exquisite customized website',

    content_title_content_2: 'Simple and easy-to-use enterprise display to store version + reservation version ',

    content_title_description_2: "Conduct professional analysis on enterprises, customers and markets, and build official image websites for enterprises.",

    content_title_description_2_1: "It is applicable to small and medium-sized or start-up enterprises, mainly displaying products and introducing services.",

    content_title_3: 'Marketing customized website ',

    content_title_content_3: 'A website focusing on marketing and SEO',

    content_title_description_3: "Massive high color value design templates + adaptive, supporting full screen DIY",

    content_title_description_3_1: "More professional SEO optimization, sitenam support and ensuring Baidu collection",

    content_title_description_3_2: "There are more languages, big data and employee sub accounts waiting for you to tease",

    content_title_4: 'Official website applet',

    content_title_content_4: 'Simple and easy-to-use enterprise display to store version + reservation version ',

    content_title_description_4: "Handle applet mall + micro mall + computer mall at one time",

    content_title_description_4_1: "Multi terminal coverage, continuous updating of 1000 + industry wide templates, personalized decoration and excellent designers",

    content_title_description_4_2: "Comprehensively manage commodities, orders, members, data and various marketing functions to detonate sales",

    give_function: "Provide professional solutions for the whole industry",

    consulting_service: "For more industries, please consult our customer service",

  },
  footText: {
     companys: 'Guangzhou youkeyi Network Technology  co., Ltd',
    address: "Address:Shop 101, No. 4, Dongbao street, Dayuan, Baiyun District, Guangzhou.",
    addresss: "Shop 101, No. 4, Dongbao street, Dayuan, Baiyun District, Guangzhou.",
    phone: "Tel:(+86) ",
    email: "Email:",
    weixin: "Scan QR  code",
    aboutUs: 'About Us',
     company: 'Company Overview',
    news: 'News ',
    notice: 'Notice',
    mediaCentre: 'Media  centre',
    report: 'Report ',
     contact: 'Contact Us',
    talentRecruitment: 'Career',
    OfficeHours: 'Office Hours',
    day1: 'Mon - Fri',
    day2: 'Sat - Sun',
    version: 'All rights reserved © 2021-2022 Guangzhou youkeyi Network Technology  co., Ltd',
    back: 'Back'
  },
   contractText: {
   
    termsofuse:'All rights reserved © 2021-2022 Guangzhou youkeyi Network Technology  co., Ltd',
  },
  HomeText: {
   
  },
  AboutUs: {
    h_c: 'About Us',
    j_t_1:'Guangzhou youkeyi Network Technology  co., Ltd. is hereinafter referred to as youyike. Youyike is an enterprise that helps small and medium-sized enterprises upgrade their digital operation. The  company has project managers, professional interface designers, interaction designers and program engineers with rich project experience. Youyike put forward the slogan of " being an easy to understand network for  customers ". Youyike put forward the slogan of " making the network simpler ".',
    j_t_2:'We provide  customers with professional  customized network  construction services. The service items include web page visual design, VI logo design, website program development, HTML5 responsive website  construction, mobile website development, micro mall, applet development, website hosting and maintenance, web system development, domain name registration, server rental at home and abroad, video, graphic design, SEO optimization ranking, etc. Help enterprises obtain user traffic more easily, and provide the most solid support for enterprises to improve products and  create value.'
    
  },
   concat: {
    h_t: 'Contact Us',
    form_t: 'Get in touch',
    ph_1: 'Message',
    
    name: 'Please enter your name',
    phone:'Please enter your phone',
    need:'Please enter your requirements',
     codemsg:'Please enter the verification  code',
    ph_3: 'Mobile No.',
    ph_4: 'Email',
    sub_t: 'Submitted',
    location: 'Shop 101, No. 4, Dongbao street, Dayuan, Baiyun District, Guangzhou..'
  },

  product:{

    type: 'Site  creation type',
    
    type_title_1: 'Youkeyi management system',
    
    type_content_1: 'Powerful function, data security and favorable price',
    
    type_title_2: 'Youkeyi Mall',
    
    type_content_2: 'One stop all inclusive server domain name',
    
    type_title_3: 'Computer version Mall',
    
    type_content_3: 'Site wide keyword marketing settings',
    
    type_title_4: 'Mobile Mall',
    
    type_content_4: 'Mass module online drag layout',
    
    type_title_5: 'Wechat Mall',
    
    type_content_5: 'Mass module online drag layout',
    
    type_title_6: 'Applet store',
    
    type_content_6: 'Mass module online drag layout',
     
    register: 'Register now',

    learMore: 'more',
    
    mall_title:'PC Mall',
    mall_content_title_1:'Visual Editing',
    mall_content_descript_1:'Drag and edit all modules in the page at will, and what you see is what you get',
    mall_content_title_2:'Massive Mall Template',
    mall_content_descript_2:'The PC / mobile terminal has a large number of mall templates to easily  create a "different" mall appearance',
    mall_content_title_3:'Mobile End  classification Template',
    mall_content_descript_3:'A variety of mobile end  classification templates to help  customers find the goods they need more easily',
    mall_content_title_4:'Custom Page',
    mall_content_descript_4:'Create a  custom page that  can be used for new products or promotion topics to increase  customer experience',
    },
  
   case:{
     case_title:'Relevant  cases',
     case_descript:'We help you embrace the new retail and marketing of the Internet',
    
     case_title_1: 'Hong Kong Medical Testing  center',

     case_descript_1: 'Professional and  comprehensive one-stop gene testing service',

     case_title_2: 'Hong Kong Zhuoxin medical laboratory',

     case_descript_2: 'Higher quality and more  convenient gene detection technology',

     case_title_3: 'Hong Kong Wanli molecular testing  center',

     case_descript_3: 'Professional, accurate and reliable gene testing services',

     case_title_4: 'Hong Kong Zhuoxin medical laboratory',

     case_descript_4: 'Higher quality and more  convenient gene detection technology',

     case_title_5: 'Reporting system ',

     case_descript_5: 'Hong Kong Zhuoxin medical laboratory reporting system',

     case_title_6: 'Working system',

     case_descript_6: 'Working system of Hong Kong Laboratory Limited',

     case_title_7: 'Youyi family',

     case_descript_7: 'Owner of Youyi family, user of Youyi family',

     case_title_8: 'Good food mall',

     case_descript_8: 'Strive to build the most professional  community fresh food service platform ',

    port_Type: 'PC Side',

    port_type_1:'App',

    port_type_2: 'Applet',

  },

  services:{

    type: 'Service  concept',
    
    type_content: 'Youyi section guides us to do every step  carefully from planning, design, front-end development, testing, acceptance, launch and operation and maintenance.',
    
    process: 'Service process',
    
    process_item_1_title: 'Preliminary  communication of specifications',
    
    process_item_1_content: 'According to your needs, we will make a detailed survey questionnaire, basic structure and quotation for you within three working days, which will help to start a project.',
    
    process_item_2_title: 'Interface design style',
    
    process_item_2_content: 'We are good at understanding the interior of your enterprise and products, presenting them to the outside with the performance of both function and beauty, and providing you with everything related to visual design.',
    
    process_item_3_title: 'Front end architecture + background development',
    
    process_item_3_content: 'The development team follows the agreed  code writing specifications to improve the standardization and maintainability of the  code. The standardized  coding is  convenient for future function expansion and reduce the  cost of system maintenance.',
    
    process_item_4_title: 'Test acceptance',
    
    process_item_4_content: 'Develop the program and test the integration of front and back pages according to the page and requirements. After the project is  completed, the  customer  can  conduct acceptance on the test website provided by us.',
    
    center: 'Service  Center',
    
    center_1_title: 'Provide "7x12 hours" customer service hotline service and "7x8 hours" technical support service.',
    
    center_2_title: 'Serve the user as soon as you receive the technical support demand to ensure the timeliness of the service.',
    
    center_3_title: 'Regularly track the project progress to ensure high-quality and efficient  completion of the project.',
    
    center_4_title: 'Take the initiative to pay a return visit after sales, keep abreast of product usage and suggestions, and  constantly improve.',
    
    },
  notices: {
    h_t: "Notice"
  },
  mediaCenter: {
    h_t: "Media  center"
  }
};

export {
  MessageEn
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js